export const getQuestionnaireClaims = (questionnaire, questionnaireMatrix) => {
  if (!questionnaire || typeof questionnaire !== 'object') {
    return [];
  }

  const matrix = Array.isArray(questionnaireMatrix)
    ? questionnaireMatrix
    : [];

  const claims = Object.keys(questionnaire)
    .filter((k) => questionnaire?.[k]?.value === 'Yes')
    .map((qId) => {
      const answers = questionnaire[qId] || {};
      const question = matrix.find((q) => q.id === qId);

      if (!question) {
        return null;
      }

      const baseKeywords = question.subtitle
        ? question.subtitle
            .split(',')
            .map((keyword) => keyword.trim())
            .filter(Boolean)
        : Array.isArray(question.keywords)
          ? question.keywords
          : question.keywords
            ? [question.keywords]
            : [];

      const claim = {
        id: qId,
        keywords: baseKeywords,
      };

      if (!question.subQuestions) {
        return claim;
      }

      const selections = answers.selections || {};

      claim.keywords = question.subQuestions
        .filter((sq) => selections[sq.id] === 'Yes')
        .map((sq) => sq.question);

      return claim;
    })
    .filter((claim) => claim && Array.isArray(claim.keywords));

  return claims;
};
